import { query } from '@confluence/query-preloader-tools';

import { DataClassificationEnabledQuery } from '../queries/DataClassificationEnabled.graphql';
import type { DataClassificationEnabledQuery as DataClassificationEnabledQueryType } from '../queries/__types__/DataClassificationEnabledQuery';

export function preloadDataClassificationEnabled() {
	return query<DataClassificationEnabledQueryType, null>({
		query: DataClassificationEnabledQuery,
	});
}
